import { render } from "./MentorSettingsPage.vue?vue&type=template&id=0d9d0ab6"
import script from "./MentorSettingsPage.vue?vue&type=script&lang=js"
export * from "./MentorSettingsPage.vue?vue&type=script&lang=js"

import exportComponent from "/root/mentoringplatform-acm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__